import { Button, Card, Paragraph } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { DealerData } from "../../interfaces/IDealerData";
import { FC } from "react";
import { Step, SubmitAnswersRequest } from "../../interfaces";
type props = { dealer: DealerData };

export const DealerCard: FC<props> = ({ dealer }) => {
    const { setSubmitAnswersRequest, setDefaultDealer, setDealersList, setFirstSearch } = useMatchMakerWizard();
    const { t } = useTranslation(["dealerselection"]);
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    return (
        <>
            {dealer && (
                <Card
                    buttons={[
                        <Button
                            type="submit"
                            className="chooseDealer"
                            id={`ChooseDealer_${dealer.id}`}
                            onClick={() => {
                                setSubmitAnswersRequest((value) => {
                                    return {
                                        ...value,
                                        selectedDealer: dealer.id,
                                        currentStep: Step.DEALER_SELECTION,
                                    } as SubmitAnswersRequest;
                                });
                                setDefaultDealer(dealer);
                                setDealersList([]);
                                setFirstSearch(true);
                            }}
                            full
                        >
                            { brand === "audi" ?t("dealerselection:dealer-card.buttonAudi"):t("dealerselection:dealer-card.button")}
                        </Button>,
                    ]}
                    footer
                    title={dealer.name}
                >
                    <Paragraph>
                        {dealer.street} {dealer.houseNumber}
                        <br />
                        {dealer.zip} {dealer.city}
                    </Paragraph>
                </Card>
            )}
        </>
    );
};
